import { render } from "./SidenavItem.vue?vue&type=template&id=a58b27f4"
import script from "./SidenavItem.vue?vue&type=script&lang=js"
export * from "./SidenavItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/KAYBU/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__